// AI-assisted: Claude 2026-08-07, human-reviewed: ausstehend
// Datums-Helfer, portiert aus docs/referenz/trainingslog.html

/** Heute als "YYYY-MM-DD" (lokale Zeitzone). */
export const todayISO = (): string => new Date().toLocaleDateString("sv-SE")

/** PB-Datum ("2026-08-07 00:00:00.000Z" oder "2026-08-07") → "YYYY-MM-DD". */
export const dayOf = (pbDate: string): string => pbDate.slice(0, 10)

/** "YYYY-MM-DD" → "Do., 07.08.2026" */
export const fmtDate = (iso: string): string =>
  new Date(iso + "T12:00").toLocaleDateString("de-DE", { weekday: "short", day: "2-digit", month: "2-digit", year: "numeric" })

/** Tage zwischen ISO-Datum und jetzt (0 = heute). */
export const daysAgo = (iso: string, now: number = Date.now()): number =>
  (now - new Date(iso + "T12:00").getTime()) / 864e5
